export default {
	userInfo: state => state.user.userInfo,
	permissions: state => state.user.permissions,
	dictMap: state => state.common.dictMap,
	configMap: state => state.common.configMap,
	token: state => state.user.token,
}